export default __webpack_public_path__ + "static/media/CAC.5f7dd9aa.jpg";